// extracted by mini-css-extract-plugin
export var accordion = "_i0-0";
export var chevron = "_i0-3";
export var closed = "_i0-2";
export var content = "_i0-4";
export var open = "_i0-1";
export var rotate = "_i0-5";